import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import { isSimpleSizingPanelState } from 'utils/is-simple-sizing-panel';

export default function useIsSimpleSizingPanel(): boolean {
  const systemPreference = useAppSelector(
    (state) =>
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
  );
  const activeStructureStepId = useAppSelector(
    (state) => state.ui.activeStructureStepId
  );

  return useMemo(
    () =>
      isSimpleSizingPanelState({
        systemPreference,
        activeStructureStepId
      }),
    [systemPreference, activeStructureStepId]
  );
}
